import React, { useState, useEffect, createContext, useContext } from "react";
import { getATAList} from "../services/otsEventService";
import { ATACode} from "../Models/ATACode";
import { useAuthentication } from "meportal/AuthenticationProvider";

 export type AtaCodeContextType = {
    ataCodes: ATACode[];
    isAtaCodeHttpError?: boolean;
  };

const AtaCodeContext = createContext<AtaCodeContextType | null>(null);

export const  AtaCodeProvider = ({ children }) => {
  const [ataCodes, setAtaCodes] = useState<any[]>([]);
  const { userData, getLatestAccessToken } = useAuthentication();
  const [isAtaCodeHttpError, setIsAtaCodeHttpError] = useState(false);
    useEffect(() => {
        if(userData.access_token !== "") {
          try {
              console.log("Getting the list of ata codes from service "); 
              getLatestAccessToken().then((token) => {
                userData.access_token = token;
                console.log("ATA Provder: Access token is " + userData.access_token);
                getATAList(userData).then((list) => {
                const ataCode = list;
                localStorage.setItem('ListOfATACode', JSON.stringify(ataCode));
                setAtaCodes(ataCode);
                setIsAtaCodeHttpError(false);
                })
                .catch((error) => {
                  console.log("Error occurred while fetching ata codes", error);
                  setIsAtaCodeHttpError(true);
                });
              });
        } catch (error) {
            console.log("Error occured while fetching ata");
            setIsAtaCodeHttpError(true);
        }
        
        }
        return () => {};
    }, [userData]);

    return (
        <AtaCodeContext.Provider value={{ ataCodes, isAtaCodeHttpError }}>
            {children}
        </AtaCodeContext.Provider>
    );
}

// Custom hook that exposes the AtaCodeContext
// Allows lower components to access AtaCodeProvider's list of ata codes
export const useAtaCodes = () => {
    const context = useContext(AtaCodeContext);
    if (!context) {
      throw new Error(
        "useAtaCodes must be used within a AtaCodeProvider. Wrap a parent component in <AtCodeProvider> to fix this error."
      );
    }
    return context;
  };